export default "__VITE_ASSET__B$oXIrnT__"